<template>
    <div :class="['form-group field-validation-error']">
        {{ error }}
    </div>
</template>

<script>
export default {
    name: "FormError",
    props: {
        error: {
            type: String,
            required: false
        }
    }
}

</script>

<style>
</style>
